// const tableItems = [
//     { title: "Member Code", key: "MemberCode", order: 1, width: "125px", table: { identifier: null, key: null } },
//     { title: "Description", key: "ResponseDescription", order: 2, width: "175px", table: { identifier: null, key: null } },
//     { title: "Returned Responses", key: "ReturnedResponses", order: 3, width: "calc(100% - 565px)", table: { identifier: null, key: null } },
//     { title: "Attempts", key: "SendAttemptCount", order: 6, width: "110px", table: { identifier: null, key: null } },
//     { title: "tprID", key: "TicketPositiveResponseId", order: 5, width: "110px", table: { identifier: null, key: null } },
//     { title: "Utility Name", key: "Utilityid", order: 4, width: "110px", table: { identifier: "utilityReferenceTable", key: "UtilityName" } },
// ].sort(({ order: a }, { order: b }) => a - b)

// export default tableItems

const tableItems = [
    { title: "Member Code", key: "MemberCode", order: 1, table: { identifier: null, key: null } },
    { title: "Description", key: "ResponseDescription", order: 2, table: { identifier: null, key: null } },
    { title: "Returned Responses", key: "ReturnedResponses", order: 3, table: { identifier: null, key: null } },
    { title: "Attempts", key: "SendAttemptCount", order: 6, table: { identifier: null, key: null } },
    { title: "tprID", key: "TicketPositiveResponseId", order: 5, table: { identifier: null, key: null } },
    { title: "Utility Name", key: "Utilityid", order: 4, table: { identifier: "utilityReferenceTable", key: "UtilityName" } },
].sort(({ order: a }, { order: b }) => a - b)

export default tableItems